var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55.15 50.52"}},[_c('polyline',{attrs:{"points":"0.36 26.65 22.63 49.72 54.73 0.27","stroke-miterlimit":"10","pathLength":"1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }